<template>
  <Property
    v-for="property in properties.slice(0, max)"
    :property="property"
    :key="property.key"
    :isEditMode="isEditMode"
    :buildingId="buildingId"
    :size="size"
    :disabled="disabled"
    @update:form="emit('update:form', $event)"
    @goToStep="emit('goToStep', $event)"
    @update:isEditMode="handleUpdateIsEditMode"
  />
</template>

<script setup>
import { ref } from "vue";
import { Property } from "@/Pages/Assets/Partials/Create";

// Emits
const emit = defineEmits(["update:form", "goToStep"]);

// Refs
const isEditMode = ref("");

// Define Props
defineProps({
  properties: { type: Array, required: true },
  buildingId: { type: String, required: false },
  max: { type: Number, required: true },
  size: { type: String, required: false },
  disabled: { type: Boolean, required: false },
});

// Functions
const handleUpdateIsEditMode = (value) => {
  isEditMode.value = value;
};
</script>
